/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_2Inputs */

const en_pc_cmp_adv_2 = /** @type {(inputs: Pc_Cmp_Adv_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs on Linux and FreeBSD, where Acrobat has no desktop app.`)
};

const zh_pc_cmp_adv_2 = /** @type {(inputs: Pc_Cmp_Adv_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可在 Linux 和 FreeBSD 上运行，而 Acrobat 在这些系统上没有桌面版。`)
};

/**
* | output |
* | --- |
* | "Runs on Linux and FreeBSD, where Acrobat has no desktop app." |
*
* @param {Pc_Cmp_Adv_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_2 = /** @type {((inputs?: Pc_Cmp_Adv_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_2(inputs)
	return zh_pc_cmp_adv_2(inputs)
});
export { pc_cmp_adv_2 as "pc.cmp.adv.2" }